import { render, staticRenderFns } from "./RequestsAlertsWidget.vue?vue&type=template&id=875c683a&scoped=true&"
import script from "./RequestsAlertsWidget.vue?vue&type=script&lang=js&"
export * from "./RequestsAlertsWidget.vue?vue&type=script&lang=js&"
import style0 from "./RequestsAlertsWidget.vue?vue&type=style&index=0&id=875c683a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875c683a",
  null
  
)

export default component.exports